// initial state
const state = () => ({
  shipping_timelines: {},
  active_timeline: 0,
});

// getters
const getters = {
  getTimelines: (state) => {
    return state.shipping_timelines;
  },
  getActiveTimeline: (state) => {
    return state.active_timeline
  },
};

// actions
const actions = {
  setTimelines({ commit }, timelines) {
    commit("setTimelines", { timelines });
  },
  activateTimeline({ commit }, sku ) {
    commit("activateTimeline", { sku });
  },
};

// mutations
const mutations = {
  setTimelines(state, { timelines }) {
    state.shipping_timelines = timelines
  },
  activateTimeline(state, { sku }) {
    if (state.shipping_timelines[sku]) {
      state.active_timeline = parseInt(state.shipping_timelines[sku])
    } else {
      state.active_timeline = 35
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
